import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import SelectStreamManager from './components/SelectStreamManager';
import { useAuthStore } from './store/authStore';
import { getLoginMode, getRouterBasename } from './config/runtimeConfig';

const NodeGroupCreation = lazy(() => import('./components/NodeGroupCreation'));

function RouteFallback() {
  return (
    <div className="min-h-screen bg-red5-dark flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red5-red mx-auto mb-4" />
        <p className="text-white">Loading...</p>
      </div>
    </div>
  );
}

function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const basename = getRouterBasename();
  const loginMode = getLoginMode();

  return (
    <Router basename={basename}>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <ErrorBoundary level="route">
                  <Login />
                </ErrorBoundary>
              )
            }
          />
          <Route
            path="/dashboard"
            element={
              <ErrorBoundary level="route">
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              </ErrorBoundary>
            }
          />
          <Route
            path="/select-sm"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : loginMode === 'direct' ? (
                <Navigate to="/login" replace />
              ) : (
                <ErrorBoundary level="route">
                  <SelectStreamManager />
                </ErrorBoundary>
              )
            }
          />
          <Route
            path="/create-node-group"
            element={
              <ErrorBoundary level="route">
                <ProtectedRoute>
                  <Suspense fallback={<RouteFallback />}>
                    <NodeGroupCreation />
                  </Suspense>
                </ProtectedRoute>
              </ErrorBoundary>
            }
          />
          <Route
            path="/"
            element={
              <Navigate
                to={isAuthenticated ? '/dashboard' : loginMode === 'cloud' ? '/select-sm' : '/login'}
                replace
              />
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
